import { Grid, Typography as Type } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const PageDetails = () => {
  const location = useLocation();
  const { pageId } = location?.state || {};
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/page", text: "Page" },
      {
        key: "3",
        href: `/page`,
        text: `View ${pageId?.page_title} Details`,
      },
    ]);
  }, [pageId]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 85%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          display: "grid",
          gridTemplateRows: "15% 80%",
          backgroundColor: "#F0F5FF",
        }}
      >
        <div style={{ backgroundColor: "white", height: "7vh", width: "100%" }}>
          <TopNavBar />

          <div
            style={{
              marginLeft: "30px",
              justifyContent: "flex-start",
              display: "flex",
            }}
          >
            <h2>View page</h2>
          </div>

          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer
          component={Paper}
          style={{
            width: "75vw",
            border: "1px solid #ccc",
            borderRadius: "15px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            marginTop: "40px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginLeft: "30px",
          }}
        >
          <h1 style={mainHeadingStyle}>page Information</h1>

          <hr />
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Sr No
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_id}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Name
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_name}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Slug
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_slug}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page JSON
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_json}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Meta Title
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_meta_title}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Meta Description
              </Type>
              <Type style={inputTextStyle}>
                {pageId?.page_meta_description}
              </Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Meta Keywords
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_meta_keywords}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page Tags
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_tags}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page OG Title
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_og_title}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page OG Description
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_og_description}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page OG Image
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_og_image}</Type>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Type variant="subtitle1" style={labelInfoStyle}>
                Page OG Alt
              </Type>
              <Type style={inputTextStyle}>{pageId?.page_og_alt}</Type>
            </Grid>
          </Grid>
        </TableContainer>
      </div>
    </div>
  );
};

const mainHeadingStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  fontSize: 16,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.black,
  display: "flex",
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
};

export default PageDetails;
